/* eslint-disable */
import React, { useState } from "react";
import {
    Alert,
    Button,
    Form,
} from "react-bootstrap";
import toast from "react-hot-toast";
import {
    useLocation,
    useNavigate,
} from "react-router-dom";
import { resetNewPassword } from "../../Services/authService";
import Loader from "../Main/Loader";
import { useSelector } from "react-redux";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const ResetPassword = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // Get email & token directly at initialization
    const params = new URLSearchParams(
        location.search
    );

    const initialToken = params.get("token");

    const [token] = useState(initialToken);
    const [password, setPassword] = useState("");
    const [
        passwordConfirmation,
        setPasswordConfirmation,
    ] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] =
        useState(false);

    const userEmail = localStorage.getItem("userEmail")


    const handleSubmit11 = async (e) => {
        e.preventDefault();

        if (!userEmail || !token) {
            setError(
                "Invalid reset link. Token or email missing."
            );
            return;
        }

        if (password.length < 8) {
            setError(
                "Password must be at least 8 characters."
            );
            return;
        }

        if (password !== passwordConfirmation) {
            setError("Passwords do not match.");
            return;
        }

        setIsLoading(true);
        setError("");
        setMessage("");

        const body = {
            email: userEmail,
            token,
            password,
            password_confirmation: passwordConfirmation,
        };

        try {
            console.log("Reset body", body);

            const response = await resetNewPassword(
                body
            );

            if (response.code === 200) {
                toast.success(
                    response.message ||
                    "Password reset successfully"
                );
                navigate("/login");
            } else if (response.code === 403) {
                toast.error(
                    response.message || "Unauthorized"
                );
            } else {
                if (response.errors) {
                    Object.values(response.errors).forEach(
                        (msg) => toast.error(msg)
                    );
                } else {
                    toast.error("Something went wrong");
                }
            }
        } catch (err) {
            console.log("Error in reset password", err);
            toast.error(
                "An error occurred while resetting password"
            );
        } finally {
            setIsLoading(false);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const body = {
            email: userEmail,
            token,
            password,
            password_confirmation: passwordConfirmation,
        };

        if (password !== passwordConfirmation) {
            toast.error("Password and confirm password does not match")
            setIsLoading(false)
            return
        }

        if (userEmail) {

            try {
                const response = await resetNewPassword(body);

                if (response.code === 200) {
                    toast.success(response.message);
                    setIsLoading(false)
                    localStorage.removeItem("userEmail")
                } else if (response.code === 422) {
                    toast.error(response.message);
                } else if (response?.result?.errors) {
                    for (const [key, value] of Object.entries(
                        response.errors
                    )) {
                        toast.error(value);
                    }
                }
            } catch (error) {
                toast.error(
                    "An error occurred. Please try again."
                );
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.error("something went wrong")
        }

    };




    return (
        <>
            <section className='mt-5'>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="">
                            <h3 className='text-center fw-bold'>Popgop Referral System</h3>
                            <div className="container py-5">
                                <div className="row justify-content-center">
                                    <div className="col-lg-6">
                                        <div className="card border-0 shadow p-3 ">
                                            <h3 className="text-center">
                                                Reset Your Password
                                            </h3>

                                            {message && (
                                                <Alert variant="success">
                                                    {message}
                                                </Alert>
                                            )}
                                            {error && (
                                                <Alert variant="danger">
                                                    {error}
                                                </Alert>
                                            )}

                                            <Form
                                                onSubmit={handleSubmit}
                                                className="mt-4">
                                                <Form.Group className="mb-3 d-none">
                                                    <Form.Label>
                                                        Email address
                                                    </Form.Label>
                                                    <Form.Control
                                                        className="position-relative "
                                                        type="email"
                                                        value={""}
                                                        readOnly
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3 position-relative">
                                                    <Form.Label>New Password</Form.Label>
                                                    <Form.Control
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder="Enter password"
                                                        className="pr-5"
                                                        value={password}
                                                        onChange={(e) =>
                                                            setPassword(
                                                                e.target.value
                                                            )
                                                        }
                                                        minLength={8}
                                                        required
                                                    />
                                                    <div
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '38px',
                                                            right: '15px',
                                                            cursor: 'pointer',
                                                            zIndex: 2,
                                                        }}
                                                    >
                                                        {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                                    </div>
                                                </Form.Group>


                                                <Form.Group className="mb-3 position-relative">
                                                    <Form.Label>Confirm New Password</Form.Label>
                                                    <Form.Control
                                                        type={showConfirmPassword ? 'text' : 'password'}
                                                        className="pr-5"
                                                        placeholder="Confirm new password"
                                                        value={passwordConfirmation}
                                                        onChange={(e) =>
                                                            setPasswordConfirmation(
                                                                e.target.value
                                                            )
                                                        }
                                                        minLength={8}
                                                        required
                                                    />
                                                    <div
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '38px',
                                                            right: '15px',
                                                            cursor: 'pointer',
                                                            zIndex: 2,
                                                        }}
                                                    >
                                                        {showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                                    </div>
                                                </Form.Group>
                                                {/* 
                                                <Form.Group className="mb-3 d-none">
                                                    <Form.Label>
                                                        New Password
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder="Enter new password"
                                                        value={password}
                                                        onChange={(e) =>
                                                            setPassword(
                                                                e.target.value
                                                            )
                                                        }
                                                        minLength={8}
                                                        required
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3 d-none">
                                                    <Form.Label>
                                                        Confirm New Password
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder="Confirm new password"
                                                        value={passwordConfirmation}
                                                        onChange={(e) =>
                                                            setPasswordConfirmation(
                                                                e.target.value
                                                            )
                                                        }
                                                        minLength={8}
                                                        required
                                                    />
                                                </Form.Group> */}

                                                <Button
                                                    type="submit"
                                                    variant="primary"
                                                    className="w-100"
                                                    disabled={isLoading}>
                                                    {isLoading ? (
                                                        <Loader />
                                                    ) : (
                                                        "Reset Password"
                                                    )}
                                                </Button>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );
};

export default ResetPassword;
